import _ from "lodash";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";
import TabUnstyled, { tabUnstyledClasses } from "@mui/base/TabUnstyled";
import { buttonUnstyledClasses } from "@mui/base/ButtonUnstyled";
import { styled } from "@mui/system";
const white = {
    50: "#fff",
    100: "#fff",
    200: "#fff",
    300: "#fff",
    400: "#fff",
    500: "#F2F4F7",
    600: "#030202",
    700: "#0059B2",
    800: "#fff",
    900: "#fff",
  };
  
  export const Tab = styled(TabUnstyled)`
    color: black;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: bold;
    background-color: transparent;
    width: 100%;
    padding: 10px 5px;
    margin: 6px 6px;
    border: none;
    border-radius: 5px;
    display: flex;
    justify-content: center;
  
    &:hover {
      background-color: ${white[400]};
    }
  
    &:focus {
      color: #fff;
      border-radius: 3px;
      outline: 2px solid ${white[200]};
      outline-offset: 2px;
    }
  
    &.${tabUnstyledClasses.selected} {
      background-color: ${white[50]};
      color: ${white[600]};
    }
  
    &.${buttonUnstyledClasses.disabled} {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `;
  
  export const  TabPanel = styled(TabPanelUnstyled)`
    width: 100%;
    font-size: 0.875rem;
  `;
  
  export const TabsList = styled(TabsListUnstyled)`
    min-width: 320px;
    background-color: ${white[500]};
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: space-between;
  `;
